import * as React from 'react';
import * as Icons from './icons';
import cn from '~modules/cn';

import './service-icon.scss';

export type ServiceIconImage = keyof typeof Icons;

interface ServiceIconProps {
    serviceId: ServiceIconImage;
    className?: string;
    ref?: React.RefObject<$TSFixMe>;
    type?: string;
    darkContent?: boolean;
    iconType?: string;
    local?: boolean;
}

const ServiceIcon = (props: ServiceIconProps): JSX.Element | null => {
    const { serviceId, className, ref, type, darkContent, iconType = 'icon', local = false } = props;
    const cls = cn(className, 'service-icon', `service-icon--${serviceId}`, { 'service-icon--dark-content': darkContent });
    if (!serviceId) {
        return null;
    }
    if (local) {
        const iconName = (serviceId + (darkContent ? 'White' : '')) as keyof typeof Icons;
        const Icon = Icons[iconName] || Icons[serviceId] || Icons.unknown;
        if (!Icon) {
            return null;
        }
        return <Icon className={className} />;
    }
    return <img src={`https://assets.stackbit.com/wizard/${type}/${serviceId}-${iconType}.svg`} className={cls} ref={ref} alt={`Logo of ${serviceId}`} />;
};

export default ServiceIcon;
